import { Link } from "react-router-dom";
import { Phone, MapPin, Instagram, Facebook, ExternalLink } from "lucide-react";
import { CONTACT } from "@/data/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="wood-bg bg-tnt-bg border-t border-tnt-border pt-10 sm:pt-14 pb-8"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-7 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-baseline gap-3">
              <span className="font-display text-4xl text-tnt-ink tracking-wider">
                TAPS &amp; TUNES
              </span>
            </div>
            <p className="text-tnt-muted mt-4 max-w-md">
              Your friendly neighbourhood bar in downtown Collingwood — live
              music, comedy, karaoke and great food, seven nights a week.
            </p>
          </div>

          <div>
            <h4 className="font-display text-xl tracking-widest text-tnt-gold mb-4">
              Visit
            </h4>
            <a
              href={CONTACT.mapsUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-address-link"
              className="flex items-start gap-2 text-tnt-ink/80 hover:text-tnt-gold transition-colors"
            >
              <MapPin className="w-4 h-4 mt-1 shrink-0" />
              <span>{CONTACT.address}</span>
            </a>
            <a
              href={`tel:${CONTACT.phoneTel}`}
              data-testid="footer-phone-link"
              className="flex items-center gap-2 text-tnt-ink/80 hover:text-tnt-gold transition-colors mt-3"
            >
              <Phone className="w-4 h-4" />
              <span>{CONTACT.phone}</span>
            </a>
          </div>

          <div>
            <h4 className="font-display text-xl tracking-widest text-tnt-gold mb-4">
              Explore
            </h4>
            <ul className="space-y-3 text-tnt-ink/80">
              <li>
                <Link to="/" data-testid="footer-nav-home" className="hover:text-tnt-gold">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/menu" data-testid="footer-nav-menu" className="hover:text-tnt-gold">
                  Menu
                </Link>
              </li>
              <li>
                <Link to="/events" data-testid="footer-nav-events" className="hover:text-tnt-gold">
                  Events
                </Link>
              </li>
              <li>
                <a
                  href={CONTACT.linktree}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-tickets-link"
                  className="inline-flex items-center gap-1 hover:text-tnt-gold"
                >
                  Tickets <ExternalLink className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="divider-glow my-7 sm:my-10" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-tnt-ink/50 font-sans">
            © {new Date().getFullYear()} Taps &amp; Tunes Bar &amp; Grill. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-tnt-ink/60">
            <a
              href="#"
              data-testid="footer-instagram"
              aria-label="Instagram"
              className="hover:text-tnt-gold transition-colors"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a
              href="#"
              data-testid="footer-facebook"
              aria-label="Facebook"
              className="hover:text-tnt-gold transition-colors"
            >
              <Facebook className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
